import React from 'react';
import '../../css/weathericons/weather-icons.scss';

const sizes = {
    '2xs': 'wi-2xs',
    'xs': 'wi-xs',
    's': 'wi-sm',
    'm': 'wi-md',
    'l': 'wi-lg',
    'xl': 'wi-xl',
    '2xl': 'wi-2xl',
}

const icons = {
    'Not available': 'wi-na',
    'Clear night': 'wi-night-clear',
    'Sunny day': 'wi-day-sunny',
    'Partly cloudy (night)': 'wi-night-alt-partly-cloudy',
    'Partly cloudy (day)': 'wi-day-sunny-overcast',
    'Not used': 'wi-na',
    'Mist': 'wi-day-haze',
    'Fog': 'wi-fog',
    'Cloudy': 'wi-cloudy',
    'Overcast': 'wi-day-sunny-overcast',
    'Light rain shower (night)': 'wi-night-alt-showers',
    'Light rain shower (day)': 'wi-day-showers',
    'Drizzle': 'wi-sprinkle',
    'Light rain': 'wi-sprinkle',
    'Heavy rain shower (night)': 'wi-night-alt-rain',
    'Heavy rain shower (day)': 'wi-day-rain',
    'Heavy rain': 'wi-rain',
    'Sleet shower (night)': 'wi-night-alt-sleet',
    'Sleet shower (day)': 'wi-day-sleet',
    'Sleet': 'wi-sleet',
    'Hail shower (night)': 'wi-night-alt-hail',
    'Hail shower (day)': 'wi-day-hail',
    'Hail': 'wi-hail',
    'Light snow shower (night)': 'wi-night-alt-snow',
    'Light snow shower (day)': 'wi-day-snow',
    'Light snow': 'wi-snow',
    'Heavy snow shower (night)': 'wi-night-alt-snow-wind',
    'Heavy snow shower (day)': 'wi-day-snow-wind',
    'Heavy snow': 'wi-snow-wind',
    'Thunder shower (night)': 'wi-night-alt-thunderstorm',
    'Thunder shower (day)': 'wi-day-thunderstorm',
    'Thunder': 'wi-thunderstorm',
};

const WeatherIcon = ({ title, size }) => {
    const icon = icons[title] || 'wi-na';
    const _size = sizes[size] || sizes['m'];

    return <i className={`wi wi-fw ${icon} ${_size}`}></i>
}

export default WeatherIcon;
